<div id="validate-id-fetch-modal-container-{{ field.key }}" class="w-100">
  <irembogov-generic-data-fetch
    [formControl]="formControl"
    [id]="field.key"
    class="w-100"
    [genericInputLength]="field.props['genericInputLength']"
    [inputLenghtAsMinLength]="field.props['inputLenghtAsMinLength'] ?? false"
    [inputLenghtAsMaxLength]="field.props['inputLenghtAsMaxLength'] ?? false"
    [placeholder]="field.props['placeholder']"
    [statusClass]="statusClass"
    [triggerType]="field.props['triggerType']"
    [disableInternalFormControl]="field.props['disableInternalFormControl']"
    [preserveFetchingStatus]="true"
    [numericOnly]="field.props['numericOnly']"
    [successMsg]="field.props['successMessage']"
    (dataFetch)="onDataFetch($event)"></irembogov-generic-data-fetch>
</div>

<irembogov-nid-verification
  #nidVerification
  [modalContainerId]="'validate-id-fetch-modal-container-' + field.key">
</irembogov-nid-verification>
